import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-scales-01',
  standalone: true,
  templateUrl: './rt-icon-scales-01.component.html',
  styleUrls: ['./rt-icon-scales-01.component.scss']
})
export class RtIconScales01Component {
  @Input() width: number | string = 17;
  @Input() height: number | string = 15;
}
